import { IconType } from 'react-icons'

import * as S from './styles'

type Variant = 'default' | 'primary'
interface BadgeProps {
  children: React.ReactNode
  Icon?: IconType
  variant?: Variant
}

const Badge = ({ children, Icon, variant = 'default' }: BadgeProps) => {
  const color: Record<Variant, string> = {
    default: 'auto',
    primary: 'color-mix(in srgb, var(--primary) 50%, transparent)'
  }

  return (
    <S.Container variant={variant}>
      {!!Icon && (
        <div style={{ minWidth: '10px', minHeight: '10px' }}>
          <Icon color={color[variant]} size={10} />
        </div>
      )}
      <span className="text">{children}</span>
    </S.Container>
  )
}

export default Badge
